import { render } from "./SendPreview.vue?vue&type=template&id=4e8745a4&scoped=true"
import script from "./SendPreview.vue?vue&type=script&lang=js"
export * from "./SendPreview.vue?vue&type=script&lang=js"

import "./SendPreview.vue?vue&type=style&index=0&id=4e8745a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8745a4"]])

export default __exports__